export default class EducationSection extends HTMLElement {
  initSlider(index) {
    this.swiperContainer = this.querySelector(`.swiper-container-${index}`);
    const swiperParams = {
      observer: true,
      observeParents: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
    };
    Object.assign(this.swiperContainer, swiperParams);
  }

  connectedCallback() {
    this.initSlider(1);

    const tabsContainer = this.querySelector('[data-id="tabs"]');
    if (tabsContainer) {
      tabsContainer.addEventListener('click', (event) => {
        if (event.target.hasAttribute('data-tab-button')) {
          const tabNumber = event.target.getAttribute('data-tab');
          this.initSlider(tabNumber);
          this.changeTab(tabNumber);
        }
      });
    }
  }

  changeTab(tabNumber) {
    const tabContent = this.querySelector(`[data-id="tab${tabNumber}"]`);
    if (!tabContent) {
      return;
    }
    this.querySelectorAll('[data-tab-content]').forEach((tab) => {
      tab.classList.remove('active-tab');
    });
    tabContent.classList.add('active-tab');
    this.querySelectorAll('[data-tab-button]').forEach((button) => {
      button.classList.remove('active-button');
      button.classList.add('body-2', 'md:body-1');
    });

    const activeButton = this.querySelector(
      `[data-tab-button][data-tab="${tabNumber}"]`,
    );

    activeButton.classList.add('active-button');
    activeButton.classList.remove('body-2', 'md:body-1');
  }
}

export const webcomponent = 'education-section';
